import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from '@headlessui/react';
import { Color } from '../../lib/types.ts';
import { Button } from '../buttons/Button.tsx';
import { cn } from '../../lib/helpers.ts';

interface ConfirmDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    heading: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    color?: Color | 'product';
}

export default function ConfirmDialog({
    isOpen,
    onClose,
    onConfirm,
    heading,
    message,
    confirmLabel = 'Potvrdit',
    cancelLabel = 'Zpět',
    color = 'product',
}: ConfirmDialogProps) {
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <DialogBackdrop
                transition
                className={cn(
                    'fixed inset-0 bg-black/75',
                    'transition-opacity duration-200 data-[closed]:opacity-0'
                )}
            />

            <div className="fixed inset-0 w-screen overflow-y-auto p-4">
                <div className="flex min-h-full w-full items-center justify-center">
                    <DialogPanel
                        transition
                        className={cn(
                            'w-full max-w-dialog-md rounded-xl bg-base-100 p-8 shadow-lg',
                            'transition-all duration-200 data-[closed]:translate-y-4 data-[closed]:scale-95 data-[closed]:opacity-0'
                        )}
                    >
                        <DialogTitle className="mb-2" as="h3">
                            {heading}
                        </DialogTitle>
                        <p className="mb-8 text-ink-800">{message}</p>

                        <footer className="flex justify-end gap-4">
                            <Button
                                color={color}
                                variant="secondary"
                                onClick={onClose}
                            >
                                {cancelLabel}
                            </Button>
                            <Button
                                color={color}
                                variant="primary"
                                onClick={onConfirm}
                            >
                                {confirmLabel}
                            </Button>
                        </footer>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
}
